var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLoanOfficerLoaded)?_c('Header'):_vm._e(),_c('v-main',{staticStyle:{"overflow":"hidden"}},[_c('v-container',{staticClass:"mt-4 pa-4",staticStyle:{"max-width":"1600px"}},[_c('router-view')],1)],1),(_vm.isLoanOfficerLoaded)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }